export default __webpack_public_path__ + "static/media/(101).f0fd485a.jpg";